import React from "react";
import "./Contactfooter.css";

/**
 * Hero-style footer section with background image and centered copy.
 * Pass a custom image URL via the `background` prop if you like.
 *
 * Example:
 * <Contactfooter background={`${process.env.PUBLIC_URL}/construction-hero.jpg`} />
 */
const Contactfooter = ({
    background = `${process.env.PUBLIC_URL}/20230405_121225.jpg`,
    onDiscover,
}) => {
    return (
        <section
            className="contactfooter"
            style={{ "--cf-bg": `url(${background})` }}
            aria-label="Company introduction"
            role="banner"
        >
            <div className="cf-overlay" aria-hidden="true" />
            <div className="cf-wrap">
                <p className="cf-kicker"> Washington State and northern Idaho</p>

                <h1 className="cf-title">
                   Quality Construction 
                    <br className="cf-br" />
                   You Can Rely On — Precision and Integrity
                </h1>

                <a
                    className="cf-btn"
                    href="/contact"
                    onClick={onDiscover}
                    aria-label="Discover more about our construction services"
                >
                    CONTACT US
                </a>
            </div>
        </section>
    );
};

export default Contactfooter;
